import gql from 'graphql-tag';
import { apollo } from 'src/features';
import { auth } from 'src/utils';

const mutation = gql`
mutation UserLogin($login: String!, $loginId: String!) {
  createAndLogin(login: $login, loginId: $loginId) {
    userId
    token
  }
}`;

function loginAgent(login, loginId) {
  return apollo.client.mutate({
    variables: {
      login,
      loginId,
    },
    mutation,
  }).then((res) => res.data.createAndLogin)
    .then((user) => {
      auth.clearAndSetStorage(user.token, 'operator');
      return user;
    });
}

export default loginAgent;
